import { BibliographyClass, CollectionFlag, Prefix } from '@/types'
import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface InspectionListCollection {
  _id: number
  searchType: SystemCode
  bibliographyRealId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  collectionId: number
  collectionNo: string
  collectionStatusShortName: string
  collectionFlag: CollectionFlag
  shelfTypeShortName: string
  shelfPlace: string
  holdingBranchCodeShortName: string
  locationBranchCodeShortName: string
  callNo: string
  collectionTypeShortName: string
  displayTitle: string
  sortTitle: string
  displaySubtitle: string
  sortSubtitle: string
  displayAuthor: string
  sortAuthor: string
  displayPublisher: string
  sortPublisher: string
  displaySize: string
  acceptPrice: number
  reserveStatusShortName: string
  reserveForwardingBranchCodeShortName: string
  reserveForwardingPlaceCodeShortName: string
  processedDate: string
  processedBranchCodeShortName: string
  processedPlaceCodeShortName: string
  unknownCount: number
}

export function InspectionListCollectionFromJSON(
  json: any
): InspectionListCollection {
  return {
    _id: exists(json, '_id') ? json._id : 0,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    bibliographyRealId: exists(json, 'bibliography_real_id')
      ? json.bibliography_real_id
      : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    collectionId: exists(json, 'collection_id') ? json.collection_id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    collectionStatusShortName: exists(json, 'collection_status_short_name')
      ? json.collection_status_short_name
      : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    shelfTypeShortName: exists(json, 'shelf_type_short_name')
      ? json.shelf_type_short_name
      : '',
    shelfPlace: exists(json, 'shelf_place') ? json.shelf_place : '',
    holdingBranchCodeShortName: exists(json, 'holding_branch_code_short_name')
      ? json.holding_branch_code_short_name
      : '',
    locationBranchCodeShortName: exists(json, 'location_branch_code_short_name')
      ? json.location_branch_code_short_name
      : '',
    callNo: exists(json, 'call_no') ? json.call_no : '',
    collectionTypeShortName: exists(json, 'collection_type_short_name')
      ? json.collection_type_short_name
      : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    sortTitle: exists(json, 'sort_title') ? json.sort_title : '',
    displaySubtitle: exists(json, 'display_subtitle')
      ? json.display_subtitle
      : '',
    sortSubtitle: exists(json, 'sort_subtitle') ? json.sort_subtitle : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    sortAuthor: exists(json, 'sort_author') ? json.sort_author : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    sortPublisher: exists(json, 'sort_publisher') ? json.sort_publisher : '',
    displaySize: exists(json, 'display_size') ? json.display_size : '',
    acceptPrice: exists(json, 'accept_price') ? json.accept_price : 0,
    reserveStatusShortName: exists(json, 'reserve_status_short_name')
      ? json.reserve_status_short_name
      : '',
    reserveForwardingBranchCodeShortName: exists(
      json,
      'reserve_forwarding_branch_code_short_name'
    )
      ? json.reserve_forwarding_branch_code_short_name
      : '',
    reserveForwardingPlaceCodeShortName: exists(
      json,
      'reserve_forwarding_place_code_short_name'
    )
      ? json.reserve_forwarding_place_code_short_name
      : '',
    processedDate: exists(json, 'processed_date')
      ? dateToPlainFormat(json.processed_date)
      : '',
    processedBranchCodeShortName: exists(
      json,
      'processed_branch_code_short_name'
    )
      ? json.processed_branch_code_short_name
      : '',
    processedPlaceCodeShortName: exists(json, 'processed_place_code_short_name')
      ? json.processed_place_code_short_name
      : '',
    unknownCount: exists(json, 'unknown_count') ? json.unknown_count : 0
  }
}
